
(function ($) {

  let initNav = function (){
    $('.nav-site__button').on('click', function (){
      let targetID = $(this).attr('aria-controls');
      let target = $('#' + targetID);
      let isOpen = $(this).attr('aria-expanded');

      // Yes, it would be more efficient to store these globally,
      // however because Drupal JS, for reasons, do not hoist.
      let navSite = $('#nav-site');
      let navSiteSecondary = $('#nav-site-secondary');
      let navSiteSearch = $('#nav-site-search');
      let navLanguages = $('#nav-languages');

      if (isOpen === 'true') {
        $(this).attr('aria-expanded', 'false');
        target.hide();

        if (targetID === 'nav-site') {
          navSiteSecondary.hide();
        }
      } else {
        $('.nav-site__button').not(this).attr('aria-expanded', 'false');
        $([navSite, navSiteSecondary, navSiteSearch, navLanguages]).each(function (){$(this).hide()});
        $(this).attr('aria-expanded', 'true');
        target.show();

        if (targetID === 'nav-site') {
          navSiteSecondary.show();
        }

        if (targetID === 'nav-site-search') {
          // focus
        }
      }
    });
  };

  let initFacets = function () {

    let isTabletOrAbove = window.matchMedia('(min-width: 47.5rem)').matches;

    if (!isTabletOrAbove) {
      $('.accordion--filters details').removeAttr('open');
    }
  };

  // --

  $(document).ready(function () {
    initNav();
    initFacets();
  });

  $(window).on('load', function () {
    // correct anything loaded on DOM load which might need adjusting (mostly once images have loaded)

  });


  // $(window).smartResize(function () {
  //   // events that need to fire after a window resize (or device rotation)
  //   Waypoint.refreshAll();
  // });

})(jQuery);
